import { Navigate } from 'react-router-dom';

import { ONBOARDING_REDIRECT_TO_AFTER_COMPLETE_KEY } from '@/constants/router';

const OnboardingExchangeRedirectPage = () => {
  window.sessionStorage.setItem(ONBOARDING_REDIRECT_TO_AFTER_COMPLETE_KEY, import.meta.env.VITE_APP_EXCHANGE_URL);

  return <Navigate to="/onboarding" replace />;
};
OnboardingExchangeRedirectPage.displayName = 'OnboardingExchangeRedirectPage';

export default OnboardingExchangeRedirectPage;
